const getCartItems = () => {
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1/cart`;
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(r => r.json())
      .then(resolve)
      .catch(reject);
  });
};

const addToCart = (code) => {
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1/cart/items/${code}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json'
      }
    })
      .then((r) => {
        if (r.ok) {
          r.json().then(resolve);
        } else {
          r.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const removeFromCart = (code) => {
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1/cart/items/${code}`;
  return new Promise((resolve, reject) => {
    fetch(url, { method: 'DELETE' })
      .then((r) => {
        if (r.ok) {
          resolve();
        } else {
          r.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

export {
  getCartItems,
  addToCart,
  removeFromCart,
};
